import { render, staticRenderFns } from "./SayfaAciklama.vue?vue&type=template&id=43461447&scoped=true"
import script from "./SayfaAciklama.vue?vue&type=script&lang=ts"
export * from "./SayfaAciklama.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43461447",
  null
  
)

export default component.exports